import querystring from 'querystring';

import { PatchScript } from '@pos-refacto/patchscript-with-react';

import { printPatchscript } from 'actions/integrations/printer';
import { createConfirmation } from 'actions/Confirmation';
import { RootDispatch } from 'reducers';

import { AdyenPaymentResponse } from '../types';

/**
 * Printing action for adyen terminals without printer
 *
 * @param data - array with 2 elements - client and merchant receipts
 */
export const printReceipt = (data: PatchScript[]) => async (
  dispatch: RootDispatch,
) => {
  const [cashierReceipt, customerReceipt] = data;

  // Print merchant copy of the payment transaction receipt
  await dispatch(printPatchscript(cashierReceipt)).catch(e => {
    // eslint-disable-next-line no-console
    console.error('Error while printing adyen receipt', e);
  });
  // Ask for confirmation to print client copy of the payment transaction receipt
  // and print one if needed
  await new Promise((resolve, reject) =>
    dispatch(
      createConfirmation(resolve, reject, {
        title: 'Print Client Receipt',
        body: 'Print receipt copy for the client?',
      }),
    ),
  )
    .then(() => dispatch(printPatchscript(customerReceipt)))
    .catch(e => {
      // eslint-disable-next-line no-console
      console.error('Error while printing adyen receipt', e);
    });
};

/**
 * Creates 2 Patchscript receipts from the information, received from the MS
 */
export const creationOfAdyenPatchscript = (
  receipts: AdyenPaymentResponse['rawResponse']['PaymentReceipt'],
): PatchScript[] => {
  return receipts.map(rec => [
    {
      align: 'center',
      type: 'text',
      pieces: [{ text: rec.DocumentQualifier }],
    },
    /* {
      type: 'text',
      pieces: [
        { text: 'IntegratedPrintFlag: ' },
        { text: rec.IntegratedPrintFlag ? 'true' : 'false' },
      ],
    },
    {
      type: 'text',
      pieces: [
        { text: 'RequiredSignatureField: ' },
        { text: rec.RequredSignatureField ? 'true' : 'false' },
      ],
    }, */
    {
      type: 'table',
      columns: [
        { baseWidth: 0, weight: 1 },
        { baseWidth: 0, weight: 1 },
      ],
      rows: rec.OutputContent.OutputText.map(({ Text }) =>
        querystring.parse(Text),
      ).map(({ name, value }) => {
        if (name && value) {
          return {
            type: 'normal',
            cells: [
              { pieces: [{ text: name }] },
              { pieces: [{ text: value }] },
            ],
          };
        }
        if (name) {
          return { type: 'normal', cells: [{ pieces: [{ text: ' ' }] }] };
        }
        return {
          type: 'normal',
          cells: [{ pieces: [{ text: name }], align: 'center' }, 'colspan'],
        };
      }),
    },
  ]);
};
